import { render, staticRenderFns } from "./AccountFactCard.vue?vue&type=template&id=c5c46a02&"
import script from "./AccountFactCard.vue?vue&type=script&lang=js&"
export * from "./AccountFactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports